// extracted by mini-css-extract-plugin
export default {"blastPage":"blastPage__BlastPage__BI1Q0"};